// extracted by mini-css-extract-plugin
export default {"headerBar":"ConfigCheckSuggestion_headerBar__MigAI","searcher":"ConfigCheckSuggestion_searcher__rfCAR"};